<template>
  <c-modal
    centered
    size="lg"
    scrollable
    v-model="model"
    no-close-on-esc
    no-close-on-backdrop
    title="Warning"
    confirmLabel="Proceed with Course Assignment"
    cancel-label="No, Never mind"
    :tag="false"
    :progressing="progressing"
    @submit="submit"
  >
    <template>
      <div>
        <p>
          All "New" items statuses will automatically be converted to "CONFIRMED" (sent to kitchen) upon course assignment.
        </p>
        <p>
          Continue with course assignment?
        </p>
      </div>
    </template>
  </c-modal>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "confirmationCourse",
        components: {CModal},
        props: {
            value: {
                required: true,
                type: Boolean,
                default: false
            },
            progressing: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            submit () {
                this.$emit('assignCourse')
            }
        }
    }
</script>

<style scoped>

</style>
